import React from 'react';
import PropTypes from 'prop-types';
import { imageUrl } from '../services/helpers';
import { Cost, Symbol } from './styled';

/** "fire" → "Fire": how a type is named on the cards. */
export const energyName = (type) => type.charAt(0).toUpperCase() + type.slice(1);

/** The symbol image for an energy type, cut from its energy card (the same images the rules use). */
export const energySymbolUrl = (type) => imageUrl(`/energy/${type}.png`);

/** One energy symbol. `size` is any CSS length; it defaults to the surrounding text's size. */
export const EnergySymbol = ({ type, size }) => (
  <Symbol src={energySymbolUrl(type)} alt={energyName(type)} title={energyName(type)} $size={size} />
);

EnergySymbol.propTypes = {
  type: PropTypes.string.isRequired,
  size: PropTypes.string,
};

/** A cost as printed on a card: one symbol per energy, like Fire Fire Colorless. */
export const EnergyCost = ({ types, size }) => (
  <Cost aria-label={`Costs ${types.map(energyName).join(', ')}`}>
    {types.map((type, i) => <EnergySymbol key={i} type={type} size={size} />)}
  </Cost>
);

EnergyCost.propTypes = {
  types: PropTypes.arrayOf(PropTypes.string).isRequired,
  size: PropTypes.string,
};
